<template>
	<div :class="classObj" class="app-wrapper">
		<div
			v-if="device === 'mobile' && sidebar.opened"
			class="drawer-bg"
			@click="handleClickOutside"
		></div>
		<!-- <sidebar class="sidebar-container" /> -->
		<div :class="{ hasTagsView: needTagsView }" class="main-container">
			<div :class="{ 'fixed-header': fixedHeader }">
				<!-- <navbar /> -->
				<tags-view v-if="needTagsView" />
			</div>
			<app-main />
			<right-panel v-if="showSettings">
				<settings />
			</right-panel>
		</div>
	</div>
</template>

<script>
import RightPanel from '@/components/RightPanel'
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'
// import EventSourceWrapper from '@/api/eventSource.js'

export default {
	name: 'Layout',
	components: {
		AppMain,
		Navbar,
		RightPanel,
		Settings,
		Sidebar,
		TagsView
	},
	mixins: [ResizeMixin],
	computed: {
		...mapState({
			sidebar: (state) => state.app.sidebar,
			device: (state) => state.app.device,
			showSettings: (state) => state.settings.showSettings,
			needTagsView: (state) => state.settings.tagsView,
			fixedHeader: (state) => state.settings.fixedHeader
		}),
		classObj() {
			return {
				hideSidebar: !this.sidebar.opened,
				openSidebar: this.sidebar.opened,
				withoutAnimation: this.sidebar.withoutAnimation,
				mobile: this.device === 'mobile'
			}
		}
	},
	created() {
		// 获取智能台账未读消息
		// this.$store.dispatch('recordsStatus/getRecordsStatus')
		// 获取聊天台账未读消息
		// this.$store.dispatch('readChatStatus/getReadChatStatus')
		const status = localStorage.getItem('chat_status') || 0
		if (status) {
			this.$store.commit('readChatStatus/SET_READCHATSTATUS', status)
		}
		setTimeout(() => {
			// this.geteventSource()
		}, 500)
	},
	methods: {
		handleClickOutside() {
			this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
		},
		// 获取sse链接 判断聊天小红点是否显示
		geteventSource() {
			const account_id = localStorage.getItem('account_id')
			// ws初始化
			this.$wsApi.connect(process.env.VUE_APP_WS_URL, account_id)
			this.$wsApi.onConnect(() => {
				// console.log('连接成功')
			})
			this.$wsApi.onMessage((cmd, msgInfo) => {
				// console.log('xxxxxxxxxx', cmd, msgInfo)
				if (cmd == 5 && msgInfo.type == 6) {
					localStorage.setItem('chat_status', msgInfo.status)
					this.$store.commit(
						'readChatStatus/SET_READCHATSTATUS',
						msgInfo.status
					)
				}
			})
			this.$wsApi.onClose((e) => {
				// console.log(e);
				if (e.code != 3000) {
					// 断线重连
					this.$message.error('连接断开，正在尝试重新连接...')
					this.$wsApi.reconnect(process.env.VUE_APP_WS_URL, account_id)
				}
			})
			// const account_id = localStorage.getItem('account_id')
			// this.eventSource = new EventSourceWrapper(account_id)
			// // 初始化 EventSource
			// this.eventSource.init()
			// // 注册事件处理程序

			// this.eventSource.on('message', (data) => {
			// 	// this.$store.commit('readChatStatus/SET_READCHATSTATUS', data.status)
			// })

			// this.eventSource.on('error', (error) => {
			// 	console.error('Error:', error)
			// })
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.app-wrapper {
	@include clearfix;
	position: relative;
	height: 100%;
	width: 100%;

	&.mobile.openSidebar {
		position: fixed;
		top: 0;
	}
}

.drawer-bg {
	background: #000;
	opacity: 0.3;
	width: 100%;
	top: 0;
	height: 100%;
	position: absolute;
	z-index: 999;
}

.fixed-header {
	position: fixed;
	top: 0;
	right: 0;
	z-index: 9;
	width: 100%;
	margin-left: 2px;
	transition: width 0.28s;
}

.hideSidebar .fixed-header {
	width: 100%;
	margin-left: 2px;
}

.mobile .fixed-header {
	width: 100%;
}
</style>
